import { Oval } from "react-loader-spinner";

const ReopenButton = ({ isReopening = false, onReopen, status }) => (
  <button
    className="bg-[#e9e9ef] text-[#404A6E] text-[10px] font-OpenSansRegular font-[600] px-3 py-[6px] min-w-[120px] rounded-[6px] disabled:opacity-50 flex items-center justify-center"
    onClick={onReopen}
    disabled={status !== 100 || isReopening}
  >
    {isReopening ? (
      <Oval
        visible={true}
        height="14"
        width="14"
        color="#1d4ed8"
        strokeWidth={8}
        secondaryColor="#c7d2fe"
        ariaLabel="reopen-ticket-loading"
      />
    ) : (
      "REOPEN TICKET"
    )}
  </button>
);

export default ReopenButton;
